import { render, staticRenderFns } from "./OrgChart.vue?vue&type=template&id=5ca0ac0a&scoped=true"
import script from "./OrgChart.vue?vue&type=script&lang=js"
export * from "./OrgChart.vue?vue&type=script&lang=js"
import style0 from "./OrgChart.vue?vue&type=style&index=0&id=5ca0ac0a&prod&lang=scss&scoped=true"
import style1 from "./OrgChart.vue?vue&type=style&index=1&id=5ca0ac0a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ca0ac0a",
  null
  
)

export default component.exports